export const validateCoordinate = (value?: number) => {
  if (value) return Number(value).toFixed(6);
  return 0;
};
